module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/InglouriousBasterds.5080a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/InglouriousBasterds.jpg
// module id = Vlr4
// module chunks = 0